import { Component } from '@angular/core';
import {NavController, NavParams, ViewController, ToastController, ModalController} from 'ionic-angular';
import { ImagePicker } from '@ionic-native/image-picker';
import { PostProvider } from '../../../providers/post/post';
import { AvatarProvider } from '../../../providers/avatar/avatar';
import {UserProvider} from "../../../providers/user/user";
import {ImageEdit} from "./image-edit/image-edit";



@Component({
  selector: 'page-new-post',
  templateUrl: 'new-post.html',
})
export class NewPostPage {


  attachments: any;
  isClub:boolean = false;
  clubId:string = '';

  croppedImage = null;

  debug:any;

  postContent:any = {
    image: '',
    content: ''
  };
  avatarContent:string = this.avatarProvider.avatarContent;

  publishing = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public imagePicker: ImagePicker,
    public toastCtrl: ToastController,
    private postProvider: PostProvider,
    public avatarProvider: AvatarProvider,
    public userProvider: UserProvider,
    private modalCtrl: ModalController
    ) {
      this.isClub = this.navParams.get('isClub');
      this.clubId = this.navParams.get('clubId');
      // Cropper

  }

    ngOnInit(){

    }

    // Convert image to base64
    handleFileSelect(evt){
      var files = evt.target.files;
      var file = files[0];

      this.presentModal(file);
    }


  presentModal(file) {
    const modal = this.modalCtrl.create(ImageEdit, {file: file});
    modal.onDidDismiss(res => {
      if(res?.image) {
        this.postContent.image = res.image;
      }
    });
    modal.present().then(() => {});
  }

  ionViewDidLoad() {

  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  openPhotoPicker() {
    this.imagePicker.getPictures({})
      .then((results) => {
        this.attachments = results;
      }, () => { });
  }

  async submit() {

    if (this.publishing) return;
    this.publishing = true;

    // Submit du post
    let toast = this.toastCtrl.create({
      message: 'Le post a été publié !',
      duration: 3000,
      position: 'top'
    });

    // Checking if we're posting in a club or general feed.
    if(this.isClub){
      this.postProvider.createClub(this.clubId, this.postContent).subscribe(
        (res) => {
          if(res.success){
            toast.present();
            this.postProvider.refreshStatus(true)
            this.dismiss();
          }
        })

    }else{
      this.postProvider.create(this.postContent).subscribe(
        (res) => {
          if(res.success){
            toast.present();
            this.postProvider.refreshStatus(true)
            this.dismiss();
          }else{
            this.debug = res;
          }

      })
    }

  }






}



// WEBPACK FOOTER //
// ./src/pages/employee/new-post/new-post.ts